<template lang="pug">
    div
        Card.card-shadow
            p(v-resize-text="{ratio: 0.4,minFontSize: '12px',maxFontSize: '36px',delay: 200}") {{ formatNumber }}
            p {{ description }}
        Spin(size="large", fix, v-if="spinShow")
</template>
<script>
import bus from "@/libs/bus.js";
import { getGroupAsset } from "@/api/groupasset.js";
import ResizeText from "vue-resize-text";
import numeral from "numeral";

export default {
    name: "AssetSingleNum",
    props: {
        groupNames: { type: Array, default: () => [] },
        category: { type: String, default: "" },
        description: { type: String, default: "" },
    },
    components: {},
    directives: {
        ResizeText,
    },
    created() {},
    beforeDestroy() {
        bus.$off("searchChartData");
    },
    data() {
        return {
            spinShow: false,
            num: "",
        };
    },
    methods: {
        getAssetData() {
            this.spinShow = true;

            getGroupAsset({
                category: this.category,
                groupNames: this.queryFilter.groupNames,
            }).then((res) => {
                this.spinShow = false;
                this.num = res.data.data;
            });
        },
    },
    mounted() {
        this.getAssetData();
        bus.$on("searchChartData", () => {
            this.getAssetData();
        });
    },
    computed: {
        formatNumber() {
            return this.num < 1000 ? this.num : numeral(this.num).format("0.00a");
        },
        queryFilter() {
            var queryFilter = this.$store.state.dashboard.queryFilter;
            return {
                groupNames: this.groupNames.length > 0 ? this.groupNames : queryFilter.groupNames,
            };
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/asset/AssetSingleNum.vue